export default __webpack_public_path__ + "static/media/logo finance (1).7f2273b2.png";